import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import fr from './locales/fr/common.json';
import ar from './locales/ar/common.json';
import en from './locales/en/common.json';
import frPro from './locales/fr/pro.json';
import arPro from './locales/ar/pro.json';
import enPro from './locales/en/pro.json';

const resources = {
  fr: { translation: { ...fr, ...frPro } },
  ar: { translation: { ...ar, ...arPro } },
  en: { translation: { ...en, ...enPro } },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'ar', 'en'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

/**
 * Met à jour l'attribut dir sur le <html> quand la langue change.
 * Arabe = RTL, autres = LTR.
 */
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);
});

export default i18n;
